module.exports = __webpack_public_path__ + "static/media/tombstone.79ce56dc.svg";